import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home as HomeIcon } from 'lucide-react';

export default function PageHero({ title, subtitle, image, imgPos, imgFit, imgBg, breadcrumbs = [] }) {
  return (
    <section className="relative pt-24 pb-16 md:pt-28 md:pb-20 overflow-hidden bg-white border-b border-slate-100">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" style={{ maskImage: 'linear-gradient(180deg, black 20%, transparent 100%)', WebkitMaskImage: 'linear-gradient(180deg, black 20%, transparent 100%)' }} />

      <div className="relative z-10 max-w-[1300px] mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
        <div>
          {/* Breadcrumbs */}
          <div className="flex items-center gap-2 text-xs text-slate-500 mb-5">
            <Link to="/" className="flex items-center gap-1 hover:text-[#0A2540] transition-colors">
              <HomeIcon size={12} /> Home
            </Link>
            {breadcrumbs.map((b, i) => (
              <React.Fragment key={i}>
                <ChevronRight size={12} />
                {b.to ? (
                  <Link to={b.to} className="hover:text-[#0A2540] transition-colors">{b.label}</Link>
                ) : (
                  <span className="text-slate-800 font-medium">{b.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-slate-900 leading-[1.05] tracking-tight max-w-3xl">
            {title}
          </h1>
          {subtitle && (
            <p className="text-base md:text-lg text-slate-600 mt-5 max-w-2xl leading-relaxed">{subtitle}</p>
          )}
          <div className="w-16 h-1 bg-[#F5B800] rounded mt-8" />
        </div>

        {image && (
          <div className="hidden lg:block relative rounded-2xl overflow-hidden aspect-[4/3] shadow-lg border border-slate-100 bg-slate-100" style={imgBg ? { background: imgBg } : undefined}>
            <img src={image} alt="" className="w-full h-full" style={{ objectPosition: imgPos || 'center', objectFit: imgFit || 'contain' }} />
          </div>
        )}
      </div>
    </section>
  );
}
